import React, { useEffect, useRef,forwardRef,useImperativeHandle  } from 'react';
import * as echarts from 'echarts';

const PieChart = forwardRef(({ data, colorMap },ref) => {
  const chartRef = useRef(null);
  const chartInstance = useRef(null);

  
useImperativeHandle(ref, () => ({
  highlightSlice: (name) => {
    chartInstance.current?.dispatchAction({
      type: 'highlight',
      seriesIndex: 0,
      name
    });
  },
  downplaySlice: (name) => {
    chartInstance.current?.dispatchAction({
      type: 'downplay',
      seriesIndex: 0,
      name
    });
  }
}));
  useEffect(() => {
    if (!chartInstance.current) {
      chartInstance.current = echarts.init(chartRef.current);
      window.addEventListener('resize', () => chartInstance.current?.resize());
    }
  
    const option = {
      tooltip: { trigger: 'item' },
      legend: { show: false },
      series: [
        {
          name: 'Status',
          type: 'pie',
          radius: ['50%', '90%'],
          center: ['50%', '50%'],
          avoidLabelOverlap: false,
          label: { show: false },
          emphasis: {
            label: {
              show: false,
              fontSize: 20,
              fontWeight: 'bold'
            }
          },
          labelLine: { show: false },
          data
        }
      ],
      color: data?.map(item => colorMap[item?.name] || '#ccc')
    };
  
    chartInstance.current.setOption(option);
  }, [data, colorMap]);
  

  return <div ref={chartRef} style={{ width: '70%', height: '250px', margin:'auto' }} />;
});

export default PieChart;
